export const PRIVACY_POLICY_URL = 'https://www.utleieappen.no/personvern/';
export const TERMS_OF_USE_URL = 'https://www.utleieappen.no/vilkar/';
export const MESSAGE_US_URL = 'https://www.m.me/utleieappen';
export const HELP_INSTRUCTIONS_URL = 'https://www.utleieappen.no/2018/06/01/sporsmal-og-svar/';
export const GOOGLE_PLAY = 'https://play.google.com/store/apps/details?id=com.utleieappen_react';
export const APP_STORE = 'https://apps.apple.com/app/id1570115662';
export const FB = 'https://www.facebook.com/utleieappen/';
export const INSTAGRAM = 'https://www.instagram.com/utleieappen/';
export const EMAIL_SUPPORT = 'post@utleieappen.no';
